/*
 * @Description:
 * @Date: 2021-03-31 16:14:05
 */
export default {
  data() {
    return {
      rules: {
        occupationType: [
          {
            required: true,
            message: '请选择认证类型',
            trigger: 'blur'
          }
        ],
        occupationAuthMode: [
          {
            required: true,
            message: '请选择认证方式',
            trigger: 'blur'
          }
        ],
        isOccupationAuth: [
          {
            required: true,
            message: '请选择职业认证',
            trigger: 'blur'
          }
        ]
      },

      isOccupationAuthArray: [
        {
          type: 1,
          value: '是'
        },
        {
          type: 0,
          value: '否'
        }
      ],
      occupationAuthModeArray: [
        {
          type: 1,
          value: '系统自动认证'
        },
        {
          type: 2,
          value: '人工认证'
        }
      ],
      occupationTypeArray: [
        {
          id: 1,
          label: '医师执业认证'
        }
      ],
      occupationMixin_way: [
        {
          type: 0,
          value: '无须认证',
          tip: '该项目将不使用认证方案'
        },
        {
          type: 1,
          value: '客户签名',
          tip: '使用该方案后，终端用户需提交客户的手绘签名'
        },
        {
          type: 2,
          value: '影像确认',
          tip: '使用该方案后，终端用户需提交现场照片及照片时间水印'
        },
        {
          type: 3,
          value: '现场直拍',
          tip: '使用该方案后，终端用户需提交摄像头直拍的现场照片'
        }
      ],
      ruleForm: {
        isOccupationAuth: undefined,
        occupationType: 1,
        occupationAuthMode: undefined
      }
    };
  },
  computed: {
    occupationMixin_authTypeTips() {
      const nowAuthType = this.ruleForm.authType;
      return this.occupationMixin_way.find(item => nowAuthType == item.type);
    }
  }
};
